import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import {Router} from "@angular/router";

@Component({
    selector: 'app-mm-multiluck-modal',
    templateUrl: './mm-multiluck-modal.component.html',
    styleUrls: ['./mm-multiluck-modal.component.scss'],
})
export class MmMultiluckModalComponent implements OnInit {

    @Input() statusMultiluck: boolean = false;
    @Input() bonus: boolean;
    @Input() slotPremiado: boolean;
    @Input() productName: string;
    @Input() image: string;
    @Input() tipoMoeda: string;
    @Input() message: string;
    @Input() imagemPremioConsolacao: string;
    @Input() bonusConsolacao: boolean;


    constructor(private modalCtrl: ModalController,
                private router: Router) { }

    ngOnInit() {
      console.log('MULTILUCK MODAL')
    }

    touchDismiss() {
        this.modalCtrl.dismiss();
        this.router.navigate(['/multiluck']);
    }

    playAgain() {
      this.modalCtrl.dismiss();
      this.router.navigate(['/multiluck'], { queryParams: { playAgain: true, id_jogo: 6 } });
    }

    imageRender() {
      // console.log('statusMultiluck', this.statusMultiluck)
      // console.log('bonus', this.bonus)
      if (this.statusMultiluck) {
        // console.log('imagem premio')
        return this.image;
      } 
      
      if (this.bonusConsolacao === true && this.imagemPremioConsolacao !== null) {
        // console.log('imagem premio consolacao')
        return this.imagemPremioConsolacao;
      }

      // console.log('imagem bad')
      const badImage = '../../../assets/icon/multiluck/bad.svg';
      return badImage;
    }

}
